import { Injectable } from '@angular/core';
import { Subject, Observable } from 'rxjs';

@Injectable()
export class MessageObservableService {

  private subject = new Subject<any>();

	public sendMessages(operation: string, message: any) {
		this.subject.next({
			operation: operation,
			message: message
		});
	}

	public clearMessages() {
		this.subject.next('');
	}

	public getMessages(): Observable<any> {
		return this.subject.asObservable();
	}

}



// WEBPACK FOOTER //
// D:/GITHUB/F210/V18/rec_ng_renta210v18/src/app/services/message-observable.service.ts